import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons"
import { RemesaFlujoTesoreriaDtoProps } from "api/DTOs/RemesaFlujoTesoreriaDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

export const REMESA_DETAIL_COLUMNS = (
  t: TFunction,
  handleDelete: (id: string) => void,
  isFlujoFromPrestamo: boolean,
  handleOpenDocumentoModal: (id: string) => void,
  conceptoRemesa?: string | null
) => {
  const columns = [
    {
      header: t("remesas.edit.tab.headerDate"),
      field: "fecha",
      key: "fecha",
      style: { width: "1%", minWidth: "1%", maxWidth: "1%", padding: "16px" },
      sortable: false,
      sortField: "fecha",
      alignCol: "left",
      body: ({ fecha }: RemesaFlujoTesoreriaDtoProps) => {
        return fecha ? frontendDateFormat(new Date(fecha)) : ""
      },
    },
    ...(!isFlujoFromPrestamo
      ? [
          {
            header: t("remesas.edit.tab.headerMaturity"),
            field: "fechaVencimiento",
            key: "fechaVencimiento",
            className: "!tw-px-2",
            style: { width: "1%" },
            sortable: false,
            sortField: "fechaVencimiento",
            alignCol: "left",
            body: ({ fechaVencimiento }: RemesaFlujoTesoreriaDtoProps) => {
              return fechaVencimiento
                ? frontendDateFormat(new Date(fechaVencimiento))
                : ""
            },
          },
        ]
      : []),
    {
      header: t("remesas.edit.tab.headerCompanyName"),
      field: "razonSocial",
      key: "razonSocial",
      style: { width: "50%" },
      sortable: false,
      sortField: "razonSocial",
    },
    ...(!isFlujoFromPrestamo
      ? [
          {
            header: t("remesas.edit.tab.headerDoc"),
            field: "documento",
            key: "documento",
            style: { width: "5%" },
            sortable: false,
            sortField: "documento",
            body: ({ documento, facturaId }: RemesaFlujoTesoreriaDtoProps) => {
              return (
                <div
                  className='hover:tw-underline hover:tw-cursor-pointer tw-text-info'
                  onClick={() =>
                    facturaId && handleOpenDocumentoModal(facturaId)
                  }
                >
                  {documento}
                </div>
              )
            },
          },
        ]
      : []),

    ...(isFlujoFromPrestamo
      ? [
          {
            header: t("remesas.edit.tab.headerConcept"),
            field: "cuentaBancariaId",
            key: "cuentaBancariaId",
            style: { width: "40%" },
            sortable: false,
            sortField: "cuentaBancariaId",
            body: conceptoRemesa,
          },
        ]
      : []),

    ...(!isFlujoFromPrestamo
      ? [
          {
            header: t("remesas.edit.tab.headerImpTot"),
            field: "importeTotal",
            key: "importeTotal",
            className: "!tw-text-end !tw-px-4",
            alignCol: "right",
            style: { width: "5%" },
            sortable: false,
            sortField: "importeTotal",
            body: ({ importeTotal }: RemesaFlujoTesoreriaDtoProps) => {
              return importeTotal ? frontendCurrency(importeTotal) : ""
            },
          },
        ]
      : []),
    {
      header: t("remesas.edit.tab.headerRemittance"),
      field: "importeRemesado",
      key: "importeRemesado",
      className: "!tw-text-end !tw-px-4",
      alignCol: "right",
      style: { width: "8%" },
      sortable: false,
      sortField: "importeRemesado",
      body: ({ importeRemesado }: RemesaFlujoTesoreriaDtoProps) => {
        return importeRemesado ? frontendCurrency(importeRemesado) : ""
      },
    },
    {
      field: "actions",
      alignCol: "right",
      style: { width: "1%", minWidth: "1%", maxWidth: "1%", padding: "8px" },
      isFixedColumn: true,
      body: ({ id }: RemesaFlujoTesoreriaDtoProps) => {
        return (
          <OptionsMenuStorybook
            id={id}
            items={[
              {
                title: `Eliminar`,
                hasRedirect: true,
                action: () => {
                  handleDelete(id)
                },
                icon: faTrashAlt,
              },
            ]}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}
